import { Add } from 'iconsax-react';
import { AvatarWithStatus } from '@/components/common/avatar-with-status';
import cn from '@/utils/merge-class-names';

export type UserAvatarProps = {
  className?: string;
  avatarUrl?: string;
  label: string;
  defaultAvatar?: 'user' | 'group' | 'tag';
  onRemove?: () => void;
};

export default function UserAvatar({ className, defaultAvatar, avatarUrl, label, onRemove }: UserAvatarProps) {
  return (
    <div className={cn('relative flex w-12 min-w-12 flex-col items-center gap-1', className)}>
      <AvatarWithStatus
        className='aspect-square size-12 rounded-full bg-base-100 bg-cover'
        imageUrl={avatarUrl}
        size={[40, 40]}
        defaultAvatar={defaultAvatar}
      />

      <div className='line-clamp-2 w-full break-all text-center text-body3 text-secondary'>{label}</div>

      {onRemove && (
        <button
          type='button'
          className='btn btn-circle btn-ghost btn-xs absolute right-0 -top-2 bg-neutral-0'
          onClick={onRemove}>
          <Add className='size-4 rotate-45' />
        </button>
      )}
    </div>
  );
}
